"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TwoColumnLayoutWithImage() {
  const {
    ref: headingRef,
    isVisible: headingVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="twocolumnlayoutwithimage" className="m-0 md:block bg-background !bg-[url(https://newmavericks.com/wp-content/uploads/2026/02/ceo-window.png)] bg-cover bg-center py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div ref={headingRef} className={`mb-12 transition-all duration-[var(--duration-medium)] ${headingVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <h2 className="font-display font-bold text-foreground ![margin:-20px_0px_0px_0px] !text-4xl max-md:!text-[32px]">Client Results</h2>
          <div className="mt-8 md:hidden">
            <img src="https://newmavericks.com/wp-content/uploads/2026/02/Clients-clients.png" data-wvc-srcset="https://newmavericks.com/wp-content/uploads/2026/02/Clients-clients.png-wvc-srcset" data-wvc-sizes="https://newmavericks.com/wp-content/uploads/2026/02/Clients-clients.png-wvc-sizes" alt="Client Results Visualization" className="w-full h-auto rounded-lg shadow-medium" loading="lazy" />
          </div>
        </div>

        <div ref={contentRef} className={`flex flex-col md:flex-row gap-12 items-center transition-all duration-[var(--duration-slow)] ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="flex-1">
            <p className="leading-relaxed text-foreground text-base md:!text-xl ml-0 md:![margin:0px_0px_0px_20px]">Over 100 leaders evolved their leadership capacity resulting in tens of billions in revenue &amp; stock value appreciation through getting major deals with the likes of: Hyundai-Kia, Siemens, General Electric, FedX, IMG, McDonalds, Chemist Warehouse, Life Health Care, Portfolio Partners, Harcourts, Top govt contractors, Governments, English Premiership League, SANZAAR Rugby, Top US College Sporting Conferences, IGV - Top China eSports company, and Cricket Australia. Approaches in our program have been scientifically validated by over 600 studies for developing leaders highest potential, performance &amp; health. We do what is right for the leaders &amp; companies we serve!</p>
          </div>
          <div className="flex-1 w-full hidden md:block">
            <img src="https://newmavericks.com/wp-content/uploads/2026/02/Clients-clients.png" data-wvc-srcset="https://newmavericks.com/wp-content/uploads/2026/02/Clients-clients.png-wvc-srcset" data-wvc-sizes="https://newmavericks.com/wp-content/uploads/2026/02/Clients-clients.png-wvc-sizes" alt="Client Results Visualization" className="w-full h-auto rounded-lg shadow-medium" loading="lazy" />
          </div>
        </div>
      </div>
    </section>;
}